import React from 'react';
import ReceiptRefundInfo from 'components/receipt/invoices/InfoBox/ReceiptRefundInfo';
import ReceiptRefundReason from 'components/receipt/invoices/RefundReason/ReceiptRefundReason';
import ReceiptRefundTotal from 'components/receipt/invoices/Total/ReceiptRefundTotal';
import ReceiptRefundListItem from 'components/receipt/invoices/ListItemBox/ReceiptRefundListItem';
import ReceiptCountingBox from 'components/receipt/invoices/CountingBox/ReceiptCountingBox';
import InvoiceActivity from 'components/receipt/invoices/InvoiceActivity/InvoiceActivity';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BrandImage from 'components/receipt/commons/BrandImage';
import ReceiptInfo from 'components/receipt/invoices/InfoBox/ReceiptInfo';
import ReceiptListItem from 'components/receipt/invoices/ListItemBox/ReceiptListItem';
import ReceiptRefundCountingBox from 'components/receipt/invoices/CountingBox/ReceiptRefundCountingBox';
import ReceiptTotal from 'components/receipt/invoices/Total/ReceiptTotal';
import LoyaltyInfo from 'components/receipt/commons/LoyaltyInfo';
import RefundedLoyaltyInfo from 'components/receipt/commons/RefundedLoyaltyInfo';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './style.receipt.css';

class ReceiptInvoices extends React.Component {
  render() {
    const { invoiceDetail, enableReceiptLogoPerOutlet } = this.props;

    return (
      <div className={`${styles['scrolled-area']} invoice`}>
        <div className={`scroll-content ${styles['col-right-inner']}`}>
          <div className={styles['receipt-container']}>
            <div
              className={`${styles['receipt-scrolled-area']}${
                styles['serrated-border']
              } invoice-receipt`}
              id="receipt"
            >
              {invoiceDetail.payment_refunds.length > 0 && (
                <div
                  className={
                    styles[
                      this._setClassNameStatusInvoice(
                        invoiceDetail.status_formatter
                      )
                    ]
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: invoiceDetail.status_formatter,
                    }}
                  />
                </div>
              )}
              {invoiceDetail.payment_refunds.map((invoiceRefund, idx) => {
                return (
                  <div key={idx}>
                    <div className={styles['mk-receipt-inner-box']} key={idx}>
                      <BrandImage
                        businessLogo={
                          enableReceiptLogoPerOutlet
                            ? invoiceDetail.outlet_logo
                              ? invoiceDetail.outlet_logo
                              : invoiceDetail.business_logo_url
                            : invoiceDetail.business_logo_url
                        }
                        businessName={
                          enableReceiptLogoPerOutlet
                            ? invoiceDetail.outlet_name
                            : invoiceDetail.business_name
                        }
                        outletAddress={invoiceDetail.outlet_address}
                        outletPhone={invoiceDetail.outlet_phone}
                      />
                      <ReceiptRefundInfo
                        invoiceDetail={invoiceDetail}
                        invoiceRefund={invoiceRefund}
                      />
                      <ReceiptRefundReason invoiceRefund={invoiceRefund} />
                      <ReceiptRefundListItem invoiceRefund={invoiceRefund} />
                      <ReceiptRefundCountingBox
                        invoiceRefund={invoiceRefund}
                        subtotal={invoiceDetail.subtotal}
                      />
                      <ReceiptRefundTotal invoiceRefund={invoiceRefund} />
                      {invoiceRefund.loyalty &&
                        Object.keys(invoiceRefund.loyalty).length > 0 && (
                          <RefundedLoyaltyInfo
                            loyalty={invoiceRefund.loyalty}
                            memberPhone={invoiceRefund.customer_phone}
                            isUnpaidInvoiceEarningPoints={this._checkIsUnpaidInvoiceEarningPoints()}
                          />
                        )}
                    </div>
                    <div className={styles['separator-receipt']} />
                    <div>
                      <div className={styles['mk-receipt-inner-box']}>
                        <BrandImage
                          businessLogo={
                            enableReceiptLogoPerOutlet
                              ? invoiceDetail.outlet_logo
                                ? invoiceDetail.outlet_logo
                                : invoiceDetail.business_logo_url
                              : invoiceDetail.business_logo_url
                          }
                          businessName={
                            enableReceiptLogoPerOutlet
                              ? invoiceDetail.outlet_name
                              : invoiceDetail.business_name
                          }
                          outletAddress={invoiceDetail.outlet_address}
                          outletPhone={invoiceDetail.outlet_phone}
                        />
                        <ReceiptInfo invoiceDetail={invoiceDetail} />
                        <ReceiptListItem invoiceDetail={invoiceDetail} />
                        <ReceiptCountingBox invoiceDetail={invoiceDetail} />
                        <ReceiptTotal invoiceDetail={invoiceDetail} />
                        {invoiceDetail.loyalty &&
                          Object.keys(invoiceDetail.loyalty).length > 0 && (
                            <LoyaltyInfo
                              loyalty={invoiceDetail.loyalty}
                              memberPhone={invoiceDetail.customer_phone}
                              isUnpaidInvoiceEarningPoints={this._checkIsUnpaidInvoiceEarningPoints()}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                );
              })}

              {invoiceDetail.payment_refunds.length === 0 && (
                <div>
                  <div
                    className={
                      styles[
                        this._setClassNameStatusInvoice(
                          invoiceDetail.status_formatter
                        )
                      ]
                    }
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: invoiceDetail.status_formatter,
                      }}
                    />
                  </div>

                  <div className={styles['mk-receipt-inner-box']}>
                    <BrandImage
                      businessLogo={
                        enableReceiptLogoPerOutlet
                          ? invoiceDetail.outlet_logo
                            ? invoiceDetail.outlet_logo
                            : invoiceDetail.business_logo_url
                          : invoiceDetail.business_logo_url
                      }
                      businessName={
                        enableReceiptLogoPerOutlet
                          ? invoiceDetail.outlet_name
                          : invoiceDetail.business_name
                      }
                      outletAddress={invoiceDetail.outlet_address}
                      outletPhone={invoiceDetail.outlet_phone}
                    />
                    <ReceiptInfo invoiceDetail={invoiceDetail} />
                    <ReceiptListItem invoiceDetail={invoiceDetail} />
                    <ReceiptCountingBox invoiceDetail={invoiceDetail} />
                    <ReceiptTotal invoiceDetail={invoiceDetail} />
                    {invoiceDetail.loyalty &&
                      Object.keys(invoiceDetail.loyalty).length > 0 && (
                        <LoyaltyInfo
                          loyalty={invoiceDetail.loyalty}
                          memberPhone={invoiceDetail.customer_phone}
                          isUnpaidInvoiceEarningPoints={this._checkIsUnpaidInvoiceEarningPoints()}
                        />
                      )}
                  </div>
                </div>
              )}
            </div>
            <InvoiceActivity invoiceDetail={invoiceDetail} />
          </div>
        </div>
      </div>
    );
  }

  _checkIsUnpaidInvoiceEarningPoints = () => {
    const { invoiceDetail } = this.props;
    return (
      invoiceDetail.total_amount_due > 0 &&
      invoiceDetail.loyalty.type === 'EARNING'
    );
  };

  _setClassNameStatusInvoice = statusFormatter => {
    const string = statusFormatter;

    if (string.includes('invoice-status-red')) {
      return 'invoice-status-red';
    }
    if (string.includes('invoice-status-green')) {
      return 'invoice-status-green';
    }
    if (string.includes('invoice-status-orange')) {
      return 'invoice-status-orange';
    }
    if (string.includes('invoice-status-grey')) {
      return 'invoice-status-grey';
    }
  };
}

ReceiptInvoices.propTypes = {
  invoiceDetail: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    data: {
      reports: state.reports,
    },
  };
}

const mapFlagsToProps = flags => {
  return {
    enableReceiptLogoPerOutlet: flags.receiptLogoPerOutlet,
  };
};

export default withFeatureFlags(mapFlagsToProps)(
  connect(mapStateToProps)(ReceiptInvoices)
);
